import { cva } from 'class-variance-authority';
import { getStatusMeta } from '@blimo/shared';
import { cn } from '../lib/utils.js';

export const badgeVariants = cva(
  'inline-flex w-fit shrink-0 items-center gap-1 whitespace-nowrap rounded-md border px-2 py-0.5 text-xs font-medium [&_svg]:size-3',
  {
    variants: {
      variant: {
        default: 'border-transparent bg-primary text-primary-foreground',
        secondary: 'border-transparent bg-secondary text-secondary-foreground',
        outline: 'text-foreground',
        neutral: 'border-transparent bg-muted text-muted-foreground',
        success: 'border-transparent bg-success-subtle text-success-subtle-foreground',
        warning: 'border-transparent bg-warning-subtle text-warning-subtle-foreground',
        destructive: 'border-transparent bg-destructive-subtle text-destructive-subtle-foreground',
        info: 'border-transparent bg-info-subtle text-info-subtle-foreground',
      },
    },
    defaultVariants: { variant: 'default' },
  },
);

/**
 * @param {import('react').ComponentProps<'span'> & { variant?: 'default'|'secondary'|'outline'|'neutral'|'success'|'warning'|'destructive'|'info' }} props
 */
export function Badge({ className, variant, ...props }) {
  return <span data-slot="badge" data-variant={variant ?? 'default'} className={cn(badgeVariants({ variant }), className)} {...props} />;
}

/**
 * Uniform status badge per domain (see @blimo/shared STATUS_MAPS).
 * @param {{ domain: 'meterReading'|'documentCheck'|'importRun'|'outboundMessage'|'messageThread', status: string, className?: string }} props
 */
export function StatusBadge({ domain, status, className }) {
  const meta = getStatusMeta(domain, status);
  return (
    <Badge variant={meta.tone} className={className}>
      <span aria-hidden="true" className="size-1.5 rounded-full bg-current" />
      {meta.label}
    </Badge>
  );
}
